import React from "react";
import Datepicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class DayPicker extends React.Component {
  changeDate(value) {
    let date = new Date(value).yyyymmdd();
    const url = window.location.origin + window.location.pathname + "?date_selection=" + date;
    window.location = url;
  }
  render() {
    let startDate = Date.parse(new Date(this.props.startDate).yyyymmdd());
    let minDate = Date.parse(new Date("2019-01-01").yyyymmdd());
    return (
      <>
        <div className="d-flex flex-row-reverse">
          <label className="datePicker" style={{marginRight: "5px"}}>
            <i className="far fa-calendar-alt" style={{right: "5px"}}></i>
            <Datepicker
              selected={this.props.dateParam ? convertUTCToLocalDate(startDate) : false}
              onChange={(value) => this.changeDate(value)}
              minDate={minDate}
              dateFormat="MMMM d, yyyy"
              placeholderText="Date Filter"
              onFocus={(e) => e.target.blur()}
            />
            {/* <i className="fas fa-sort-down"></i> */}
          </label>
        </div>
      </>
    );
  }
}

export default DayPicker;
